import React from 'react';
export function IntroSection() {
  return <section id="intro" className="py-20 md:py-32 bg-[#f5f0eb]" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-113">
          {/* Left Column: All text */}
          <div className="space-y-8" data-id="element-114">
            <div className="space-y-6 text-lg text-teal/80 leading-relaxed" data-id="element-115">
              <p data-id="element-116">
                You know the feeling. Comparing yourself to everyone else's
                curated highlights while your own life feels messy and
                uncertain. Saying yes when you mean no. Lying awake replaying
                conversations, wondering if you said the wrong thing. Feeling
                anxious about being anxious.
              </p>
              <p data-id="element-117">
                In a world that celebrates hustle culture, demands constant
                productivity, and makes it look like everyone else has it
                together, accepting yourself as you are right now feels
                impossible.
              </p>
            </div>

            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border-l-4 border-terracotta" data-id="element-118">
              <blockquote className="text-xl md:text-2xl font-medium text-teal italic mb-6" data-id="element-119">
                "The curious paradox is that when I accept myself just as I am,
                then I change."
              </blockquote>
              <cite className="block text-base font-medium text-sage not-italic mb-8" data-id="element-120">
                — Carl Rogers
              </cite>
              <p className="text-lg text-teal/80" data-id="element-121">
                That's where we start. I'm here to meet you exactly where you
                are, without judgement, without pressure to have it all figured
                out.
              </p>
            </div>
          </div>

          {/* Right Column: Photo */}
          <div className="relative max-w-sm mx-auto lg:max-w-none" data-id="element-122">
            <div className="rounded-2xl overflow-hidden shadow-md aspect-[4/5]" data-id="element-123">
              <img src="https://cdn.magicpatterns.com/uploads/1tq4yznxpTswXCJDHUGFZS/IMG_4250_Original.jpg" alt="Jess sitting at a café" className="w-full h-full object-cover" style={{
              objectPosition: '50% 20%'
            }} data-id="element-124" />
            </div>
            <div className="absolute -top-3 -right-3 w-8 h-8 bg-terracotta/20 rounded-full -z-10" data-id="element-125" />
            <div className="absolute -bottom-3 -left-3 w-12 h-12 bg-sage/15 rounded-full -z-10" data-id="element-126" />
          </div>
        </div>
      </div>
    </section>;
}